"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringArrayIndexesType = void 0;
const Utils_1 = require("../../../utils/Utils");
exports.StringArrayIndexesType = Utils_1.Utils.makeEnum({
    HexadecimalNumber: 'hexadecimal-number',
    HexadecimalNumericString: 'hexadecimal-numeric-string'
});
